/* Koffyland landing funnels — shared interactions. v2 2026-07-14.
   Progressive enhancement only: every page works without JS. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Sticky mobile dock: show once the hero CTA scrolls away ---- */
  var dock = document.querySelector('[data-kl-dock]');
  var dockSentinel = document.querySelector('[data-kl-dock-sentinel]');
  if (dock && dockSentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      dock.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(dockSentinel);
  }

  /* Retreat while the visitor is using the content targeted by the dock. */
  var dockZones = document.querySelectorAll('[data-kl-dock-zone]');
  if (dock && dockZones.length && 'IntersectionObserver' in window) {
    var visibleDockZones = new Set();
    var dockZoneObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visibleDockZones.add(entry.target);
        else visibleDockZones.delete(entry.target);
      });
      dock.classList.toggle('is-content-active', visibleDockZones.size > 0);
    }, { threshold: 0.04 });
    dockZones.forEach(function (zone) { dockZoneObserver.observe(zone); });
  }

  /* ---- Copy buttons ---- */
  document.querySelectorAll('[data-kl-copy]').forEach(function (btn) {
    var original = btn.textContent;
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-kl-copy');
      var done = function () {
        btn.classList.add('is-copied');
        btn.textContent = 'Copié !';
        setTimeout(function () { btn.classList.remove('is-copied'); btn.textContent = original; }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, done);
      } else { done(); }
    });
  });

  /* ---- Smooth anchors (respect reduced motion) ---- */
  document.querySelectorAll('a[href^="#"][data-kl-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      var input = target.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reduced ? 0 : 450);
    });
  });

  /* ---- LP3: countdown to Paris midnight ---- */
  var count = document.querySelector('[data-kl-midnight]');
  if (count) {
    var hours = document.querySelector('[data-kl-midnight-hours]');
    var minutes = document.querySelector('[data-kl-midnight-minutes]');
    var seconds = document.querySelector('[data-kl-midnight-seconds]');
    var clock = count.closest('.kla-clock');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      try {
        var now = new Date();
        var paris = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
        var left = 24 * 3600 - (paris.getHours() * 3600 + paris.getMinutes() * 60 + paris.getSeconds());
        if (left <= 0 || left > 86400) left = 86400;
        var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
        var label = pad(h) + ' h ' + pad(m) + ' min ' + pad(s) + ' s';
        count.textContent = label;
        if (hours) hours.textContent = pad(h);
        if (minutes) minutes.textContent = pad(m);
        if (seconds) seconds.textContent = pad(s);
        if (clock) clock.setAttribute('aria-label', 'Prochaine sélection dans ' + label);
      } catch (e) { count.textContent = 'minuit'; }
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- LP1: the map ---- */
  var stage = document.querySelector('[data-klm]');
  if (!stage) return;

  if (dock && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      dock.classList.toggle('is-map-active', entries[0].isIntersecting);
    }, { threshold: 0.18 }).observe(stage);
  }

  var pins = Array.prototype.slice.call(stage.querySelectorAll('[data-klm-pin]'));
  var labels = Array.prototype.slice.call(stage.querySelectorAll('[data-klm-label]'));
  var routes = {};
  stage.querySelectorAll('[data-klm-route]').forEach(function (p) { routes[p.getAttribute('data-klm-route')] = p; });
  var card = document.querySelector('[data-klm-card]');
  var data = window.KL_ORIGINS || {};
  var order = pins.map(function (p) { return p.getAttribute('data-klm-pin'); });
  var current = -1;
  var autoTimer = null;
  var productCache = {};

  function formatPrice(cents) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function hydrateProduct(id, o) {
    if (!o || !o.handle || !card) return;
    var visual = card.querySelector('.klm-card__visual');
    var applyProduct = function (product) {
      if (order[current] !== id || !product) return;
      var image = card.querySelector('.klm-card__visual img');
      var fallback = card.querySelector('[data-klm-image-fallback]');
      var waitingForImage = false;
      if (product.featured_image) {
        waitingForImage = true;
        if (!image) {
          image = document.createElement('img');
          image.loading = 'eager';
          visual.insertBefore(image, visual.querySelector('figcaption'));
        }
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=640';
        image.alt = product.title || o.cafe;
        if (fallback) fallback.remove();
        var revealImage = function () { if (order[current] === id) visual.classList.remove('is-loading'); };
        if (image.decode) image.decode().then(revealImage, revealImage);
        else { image.addEventListener('load', revealImage, { once: true }); image.addEventListener('error', revealImage, { once: true }); }
      }
      var price = card.querySelector('[data-klm-price]');
      var availability = card.querySelector('[data-klm-availability]');
      if (price && typeof product.price === 'number') price.textContent = formatPrice(product.price);
      if (availability) availability.textContent = product.available ? 'Disponible' : 'Épuisé';
      var linkLabel = card.querySelector('[data-klm-link-label]');
      if (linkLabel) linkLabel.textContent = product.available ? 'Goûter cette origine' : 'Découvrir cette origine';
      if (!waitingForImage) visual.classList.remove('is-loading');
    };
    if (productCache[id]) { applyProduct(productCache[id]); return; }
    visual.classList.add('is-loading');
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'products/' + o.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
      .then(function (product) { productCache[id] = product; applyProduct(product); })
      .catch(function () { visual.classList.remove('is-loading'); });
  }

  function renderCard(id, idx) {
    var o = data[id];
    if (!o || !card) return;
    card.classList.remove('is-changing');
    void card.offsetWidth;
    card.classList.add('is-changing');
    card.querySelector('[data-klm-origin]').textContent = o.pays;
    card.querySelector('[data-klm-place]').textContent = o.lieu;
    card.querySelector('[data-klm-bean]').textContent = o.cafe;
    card.querySelector('[data-klm-roaster]').textContent = o.torrefacteur;
    card.querySelector('[data-klm-alt]').textContent = o.altitude ? 'Cultivé à ' + o.altitude : '';
    card.querySelector('[data-klm-count]').textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(order.length).padStart(2, '0');
    var link = card.querySelector('[data-klm-link]');
    link.href = '/products/' + o.handle;
    var notes = card.querySelector('[data-klm-notes]');
    notes.innerHTML = '';
    (o.notes || []).forEach(function (n) {
      var s = document.createElement('span');
      s.textContent = n;
      notes.appendChild(s);
    });
    hydrateProduct(id, o);
  }

  function activate(idx, user) {
    idx = (idx + order.length) % order.length;
    if (idx === current) return;
    current = idx;
    var id = order[idx];
    card.setAttribute('aria-live', user ? 'polite' : 'off');
    pins.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-klm-pin') === id); });
    labels.forEach(function (label) { label.classList.toggle('is-active', label.getAttribute('data-klm-label') === id); });
    Object.keys(routes).forEach(function (k) { routes[k].classList.toggle('is-active', k === id); });
    renderCard(id, idx);
    if (user) stopAuto();
  }

  function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }

  pins.forEach(function (p, i) {
    p.setAttribute('tabindex', '0');
    p.setAttribute('role', 'button');
    var o = data[p.getAttribute('data-klm-pin')];
    if (o) p.setAttribute('aria-label', o.pays + ' — voir ce café');
    p.addEventListener('click', function () { activate(i, true); });
    p.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(i, true); }
    });
  });
  document.querySelectorAll('[data-klm-prev]').forEach(function (b) {
    b.addEventListener('click', function () { activate(current - 1, true); });
  });
  document.querySelectorAll('[data-klm-next]').forEach(function (b) {
    b.addEventListener('click', function () { activate(current + 1, true); });
  });

  /* region tabs (mobile): animate the viewBox to frame the region */
  var svg = stage.querySelector('svg');
  var regions = window.KL_REGIONS || {};
  var vbHome = (svg.getAttribute('viewBox') || '0 0 1420 581').split(' ').map(Number);
  var vbAnim = null;
  function setViewBox(v) { svg.setAttribute('viewBox', v.map(function (n) { return Math.round(n * 10) / 10; }).join(' ')); }
  function animateViewBox(target) {
    var from = svg.getAttribute('viewBox').split(' ').map(Number);
    if (vbAnim) cancelAnimationFrame(vbAnim);
    if (reduced) { setViewBox(target); return; }
    var t0 = null, DUR = 550;
    var step = function (ts) {
      if (!t0) t0 = ts;
      var t = Math.min(1, (ts - t0) / DUR);
      var e = 1 - Math.pow(1 - t, 3);
      setViewBox(from.map(function (f, i) { return f + (target[i] - f) * e; }));
      if (t < 1) vbAnim = requestAnimationFrame(step);
    };
    vbAnim = requestAnimationFrame(step);
  }
  function frameRegion(name) {
    if (name === 'monde') { animateViewBox(vbHome); return; }
    var b = regions[name];
    if (!b) return;
    var padX = 80, padY = 60;
    var x = b.x0 - padX, y = b.y0 - padY;
    var w = (b.x1 - b.x0) + padX * 2, h = (b.y1 - b.y0) + padY * 2;
    // Match the on-screen aspect ratio so "meet" doesn't letterbox.
    var rect = svg.getBoundingClientRect();
    var aspect = rect.width && rect.height ? rect.width / rect.height : w / h;
    if (w / h < aspect) { var w2 = h * aspect; x -= (w2 - w) / 2; w = w2; }
    else { var h2 = w / aspect; y -= (h2 - h) / 2; h = h2; }
    animateViewBox([x, y, w, h]);
  }
  var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-klm-tab]'));
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      frameRegion(t.getAttribute('data-klm-tab'));
      var first = t.getAttribute('data-klm-first');
      if (first) {
        var i = order.indexOf(first);
        if (i > -1) activate(i, true);
      }
      stopAuto();
    });
  });
  // Mobile default frame: start on the Americas so pins aren't microscopic.
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  if (mobile && tabs.length) {
    tabs[0].setAttribute('aria-selected', 'true');
    frameRegion(tabs[0].getAttribute('data-klm-tab'));
  }

  activate(0, false);
  if (!reduced) {
    autoTimer = setInterval(function () { activate(current + 1, false); }, 7000);
    stage.addEventListener('pointerdown', stopAuto, { once: false });
  }
})();
